import _ from 'lodash'
import Backbone from 'backbone'
import template from './change-total-display.hbs'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import selects from 'scoreboard/components/selects'
import dropdown from 'scoreboard/components/dropdown'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import i18n from 'scoreboard/components/i18n'
import Dataset from 'scoreboard/datasets/model/dataset'
var TOTAL = Dataset.TOTAL
import renderFieldDropdown from './render-field-dropdown'
import AggregationType from './model/aggregation-type'
import * as aggregationTypeOptions from './aggregation-type-options'
const { SUM } = AggregationType

/**
 * The Change Total Display dialog for the datasets overview and datasets edit.  See
 * https://github.com/SpiderStrategies/Scoreboard/issues/12824
 */
var ChangeTotalDisplay = Backbone.View.extend({

	/** @type {Dataset} */
	model: null,

	tagName: 'form',

	className: 'change-total-display',

	events: {
		'click [name=display]': 'changeDisplay',
		'change [name=aggregationFieldIdentifier]': 'changeField'
	},

	/**
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Number} options.aggregationFieldId the default aggregation field ID
	 *
	 * @param {String} options.aggregationType the default aggregation type
	 *
	 * @param {Number} options.aggregationVisibleLinkedFieldId the default
	 * visible linked field ID
	 *
	 * @param {Boolean} [options.filterThroughLocalDataset=false] whether the
	 * total display should be filtered through the local dataset
	 */
	initialize: function(options) {
		this.options = options || {}
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false
		})
	},

	render: function() {
		this.$el.empty().append(template(this.model.attributes))

		this.renderToggle()
		this.renderAggregationFieldDropdown()
		//this.renderFilterThroughToggle()

		var data = { aggregationType: this.options.aggregationType }
		this.aggregationFieldIdentifier = data.aggregationFieldIdentifier =
			this.model.idsToFieldIdentifier({
				fieldId: this.options.aggregationFieldId,
				visibleLinkedFieldId: this.options.aggregationVisibleLinkedFieldId
			})
		formHelper.writeToDom(data, this.el)

		this.changeDisplay()
		this.changeField()

		this.formView.start()
		return this
	},

	renderToggle: function() {
		var fieldId = this.options.aggregationFieldId
		let custom = (fieldId && fieldId > 0) || this.options.aggregationVisibleLinkedFieldId
		this.toggle = new LabeledToggle({
			value: custom ? 'custom' : 'total',
			options: [ {
				value: 'total',
				label: i18n.get('datasets.total.tracked', this.model.get('tracked'))
			}, {
				value: 'custom',
				label: 'datasets.total.display.custom'
			} ]
		})
		this.toggle.on('change', function() {
			this.changeDisplay()
			this.formView.change()
			_.result(this.markedField, 'clearError')
		}.bind(this))

		this.$('.type-toggle').append(this.toggle.el)
		this.toggle.render()
	},

	renderAggregationFieldDropdown: function() {
		this.markedField = renderFieldDropdown({
			el: this.$('[name=aggregationFieldIdentifier]'),
			dataset: this.model,
			required: true,
			includeTotal: true,
			// the native total is chosen using the toggle instead
			includeNativeTotal: false,
			selectedId: this.aggregationFieldIdentifier
		})
	},

	/*
	renderFilterThroughToggle: function() {
		this.filterThroughToggle = new FilterThroughToggle({
			el: this.$('.filter-through'),
			model: this.model,
			checked: this.options.filterThroughLocalDataset,
			fieldIdentifier: this.$('[name=aggregationFieldIdentifier]').val()
		}).render()
	},
	*/

	/**
	 * Ensure the form appearance is correct based on the selection for
	 * the currently selected display (total or custom)
	 */
	changeDisplay: function() {
		var display = this.toggle.val()
		this.$('.custom, .aggregation-type').toggleClass('is-not-displayed', display !== 'custom')
		if (display === 'custom') {
			this.changeField()
		}
		//this.toggleFilterThroughToggle()
	},

	/**
	 * When changing the field, switch to the default aggregation type
	 */
	changeField: function() {
		let fieldIdentifier = this.$('[name=aggregationFieldIdentifier]').val()
		//this.toggleFilterThroughToggle()

		if (!fieldIdentifier) {
			this.$('.aggregation-type').addClass('is-not-displayed')
			return
		}

		let field = this.model.getFieldByFieldIdentifier(fieldIdentifier)
		if (!field) {
			this.$('.aggregation-type').addClass('is-not-displayed')
			return
		}

		let none = _.get(field, 'aggregationType') === 'none'

		// render the aggregationType dropdown
		this.$('.aggregation-type').removeClass('is-not-displayed')

		let aggregationTypes = aggregationTypeOptions.totalDisplay(this.model,
			fieldIdentifier)
		dropdown.idLabels(this.$('[name=aggregationType]').empty(),
			aggregationTypes)

		let aggregationTypeEl = this.$('[name=aggregationType]')
		// try to use the specified aggregation type, or if not use the default
		// for the field
		let aggregationType = this.options.aggregationType || field.aggregationType

		// make sure the aggregation type is valid
		let validAggregation = !!_.find(aggregationTypes, (aggregation) => {
			return aggregation.id === aggregationType
		})
		if (!validAggregation) {
			aggregationType = field.aggregationType
		}

		// fields with the none aggregation type always use none for the
		// aggregation type (#19817)
		if (none) {
			aggregationType = 'none'
		}
		// #18512 #19003 #19817 fields with aggregation type = none shouldn't be editable
		this.$('[name=aggregationType]').prop('disabled', none)

		// make sure something is selected in the dropdown
		if (aggregationType) {
			aggregationTypeEl.val(aggregationType)
		} else {
			aggregationTypeEl[0].selectedIndex = 0
		}
		selects.update(aggregationTypeEl)
	},

	submit: function() {
		var data
		if (this.toggle.val() == 'total') {
			data = {
				aggregationFieldId: TOTAL,
				// #55113 be sure to specify an aggregation type to avoid
				// problems
				aggregationType: SUM,
				aggregationVisibleLinkedFieldId: null
			}
		} else {
			data = formHelper.readFromDom(this.el)
			let ids = this.model.fieldIdentifierToIds(data.aggregationFieldIdentifier)
			data.aggregationFieldId = ids.fieldId
			if (ids.visibleLinkedFieldId) {
				data.aggregationVisibleLinkedFieldId = ids.visibleLinkedFieldId
			}
			delete data.aggregationFieldIdentifier
		}
		// this is here so i don't have to duplicate it in datasets-overview and
		// datasets-edit
		this.model.set(data)
		this.trigger('done', data)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.toggle, this.markedField,
			this.filterThroughToggle], 'remove')
	}

})

export default ChangeTotalDisplay

ChangeTotalDisplay.__filename__ = 'datasets/change-total-display.js'
